const C = {
  name: "Blog",
  dimensions: { width: 40, height: 39 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_3998)">
    <path d="M1 2.00293H39C39.55 2.00293 40 1.55293 40 1.00293C40 0.45293 39.55 0.00292969 39 0.00292969H1C0.45 0.00292969 0 0.45293 0 1.00293C0 1.55293 0.45 2.00293 1 2.00293Z" />
    <path d="M39 9.00537H1C0.45 9.00537 0 9.45537 0 10.0054C0 10.5554 0.45 11.0054 1 11.0054H39C39.55 11.0054 40 10.5554 40 10.0054C40 9.45537 39.55 9.00537 39 9.00537Z" />
    <path d="M39 18.0077H1C0.45 18.0077 0 18.4577 0 19.0077C0 19.5577 0.45 20.0077 1 20.0077H39C39.55 20.0077 40 19.5577 40 19.0077C40 18.4577 39.55 18.0077 39 18.0077Z" />
    <path d="M26.66 35.5423L23.36 36.0124L23.83 32.7115L30.67 25.8697L32.79 27.9903C33.18 28.3804 33.18 29.0105 32.79 29.4006L26.66 35.5423ZM34.2 22.3388L36.32 24.4593C36.71 24.8494 36.71 25.4796 36.32 25.8697L34.91 27.2801L32.79 25.1595C32.4 24.7694 32.4 24.1393 32.79 23.7492L34.2 22.3388ZM39 27.01H38.01L38.44 26.5799C39.22 25.7997 39.22 24.5294 38.44 23.7492L35.61 20.9184C35.23 20.5383 34.73 20.3282 34.2 20.3282C33.67 20.3282 33.16 20.5383 32.79 20.9184L26.7 27.01H1C0.45 27.01 0 27.4601 0 28.0103C0 28.5604 0.45 29.0105 1 29.0105H24.7L22.42 31.2911C22.11 31.6012 21.91 32.0013 21.85 32.4314L21.38 35.7223C21.37 35.8123 21.37 35.9124 21.37 36.0024H1C0.45 36.0024 0 36.4525 0 37.0027C0 37.5528 0.45 38.0029 1 38.0029H23C23.04 38.0029 23.08 37.9829 23.11 37.9829C23.19 37.9929 23.27 38.0029 23.35 38.0029C23.45 38.0029 23.54 37.9929 23.64 37.9829L26.94 37.5128C27.37 37.4528 27.77 37.2527 28.07 36.9426L36.01 29.0105H39C39.55 29.0105 40 28.5604 40 28.0103C40 27.4601 39.55 27.01 39 27.01Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_3998">
    <rect width="40" height="38" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>

  `
};
export {
  C as Blog
};
